import axios from 'axios';
import router from '@/router/index.js';
import store from '@/store';
import { Message } from 'element-ui'

// 创建一个axios实例
const service = axios.create({
    baseURL: '/', // url = base url + request url
    // baseURL: '',
    // baseURL: 'https://cfa.indata3.com', // /url = base url + request url
    withCredentials: true, // send cookies when cross-domain requests
    timeout: 10000 // request timeout 10s
});

// 请求拦截器
service.interceptors.request.use(config => {
    // do something before request is sent
    const token = store.state.token;
    console.log(token,'token')
        // 如果当前存有token,就加在请求头上
    if (token) {
        config.headers['token'] = `${token}`;
    }
    // config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
    return config;
}, error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error);
});

// 响应拦截器
service.interceptors.response.use(response => {
    // console.log(response.data,"response=======")
    //do something before response
    if (response.data.code==1) {
        return response.data;

    }else if(response.data.code==-1){//登录失效回到登录页面
        Message.warning('登录失效，请重新登录！');
        setTimeout(function () {
            router.replace({
                path: '/login',
            })
        },1000)
    } else {
        Message.error(response.data.msg);
        return response.data;
        //不走123
    }
},
    error => {
        console.log('err' + error); // for debug
        if (error.response.code == 1) {
            router.replace({
                path: '/login',
            })
        } else {
            Message.warning(error.response.data);
        }
        return Promise.reject(error);
    })

export default service;